import React, { forwardRef } from 'react';
import Container from 'ls-common-client/dist/components/Container';
import { useTheme } from 'styled-components';

const Divider = forwardRef(
  (
    {
      vertical,
      thin,
      color,
      margin,
      space,
      backgroundColor: dump1,
      background: dump2,
      width,
      height,
      ...props
    },
    ref
  ) => {
    const theme = useTheme();
    const spaceValue =
      space === undefined || theme.margin[space] === undefined
        ? '1em'
        : theme.margin[space];
    const size = thin ? '1px' : '2px';
    const w = vertical ? size : width || '100%';
    const h = vertical ? height || '' : size;

    const marginValue = vertical ? `0 ${spaceValue}` : `${spaceValue} 0`;
    return (
      <Container
        ref={ref}
        width={w}
        height={h}
        flex="0 0 auto"
        backgroundColor={color || theme.background.background400}
        {...{ vertical, thin }}
        {...props}
        margin={margin === undefined ? marginValue : margin}
      />
    );
  }
);

export default Divider;
